<template>
    <div>
      <b-card no-body >

        <b-card-body>
          <div class="d-flex justify-content-between  flex-wrap">
            <!-- Registar Empresa  -->
            <b-form-group
                label-for="filterInput"
                class="mb-0"
            >
              <b-button
                  variant="gradient-primary"
                  size="sm"
                  class="mr-1"
                  @click="traerCategorias"
              >
                <feather-icon
                    icon="RefreshCwIcon"
                />
              </b-button>
              <b-button
                  v-if="$can('create', 'BBSS Categorias')"
                  variant="gradient-primary"
                  size="sm"
                  v-b-modal.modal-registrar
              >
                <feather-icon
                    icon="PlusIcon"
                    class="mr-50"
                />
                <span class="align-middle">Registrar Categoría</span>
              </b-button>
            </b-form-group>

            <!-- filter -->
            <b-form-group
                label-for="filterInput"
                class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Buscar"
                />
                <b-input-group-append>
                  <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                  >
                    Borrar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

          </div>
        </b-card-body>

        <b-table
            hover
            responsive
            small
            class="position-relative"
            sticky-header="58vh"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"

            @filtered="cPaginacion"

            :busy="loading"
            show-empty
            empty-text="No se encontraron datos en esta tabla."
        >
          <template #table-busy>
            <div class="text-center text-dark my-1">
              <b-spinner class="align-middle"></b-spinner> &emsp;
              <strong>Obteniendo datos...</strong>
            </div>
          </template>
          <template #cell(estado)="data">
            <b-badge :variant="status[1][parseInt(data.value)]">
              {{ status[0][parseInt(data.value)] }}
            </b-badge>
          </template>
          <template #cell(modulo)="data">
            {{ status_modulo[0][parseInt(data.value)] }}
          </template>
          <template #cell(created)="data">
            <span class="text-nowrap">
              {{
                new Date(data.value).toLocaleString('pe-PE', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  localeMatcher: 'best fit',
                  timeZone: 'America/Lima'
                })
              }}
            </span>
          </template>
          <template #cell(modified)="data">
            <span class="text-nowrap">
              {{
                new Date(data.value).toLocaleString('pe-PE', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  localeMatcher: 'best fit',
                  timeZone: 'America/Lima'
                })
              }}
            </span>
          </template>
          <template #cell(acciones)="data">
            <div class="text-nowrap">
              <feather-icon
                  v-if="$can('update', 'BBSS Categorias')"
                  :id="`btn_${data.item.id}_editar`"
                  icon="EditIcon"
                  size="16"
                  class="mr-1"
                  @click="abrirModalEditar(data.item)"
              />
              <b-tooltip
                  title="Editar registro"
                  :target="`btn_${data.item.id}_editar`"
              />
            </div>
          </template>
        </b-table>
        <!-- <b-card-body class="d-flex justify-content-between flex-wrap pt-0"> -->
          <!-- page length -->
          <!-- <b-form-group
              label="Mostrar"
              label-cols="5"
              label-align="left"
              label-size="sm"
              label-for="sortBySelect"
              class="text-nowrap mb-md-0 mr-1"
          >
            <b-form-select
                id="perPageSelect2"
                v-model="perPage"
                size="sm"
                inline
                :options="pageOptions"
            />

          </b-form-group> -->

          <!-- pagination -->
          <!-- <div>
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>
          </div> -->
        <!-- </b-card-body> -->
      </b-card>


      <b-modal
          id="modal-registrar"
          ref="modal-registrar"
          no-close-on-esc
          no-close-on-backdrop
          cancel-variant="secondary"
          ok-title="Registrar"
          cancel-title="Cancelar"
          :cancel-disabled="loadingRegistrar"
          :ok-disabled="loadingRegistrar"
          size="md"
          centered
          title="Ingresar Nuevo Registro"
          @ok="okModalRegistro"
          @show="resetModal"
          @hidden="resetModal"
      >
        <div v-if="loadingRegistrar"  align="center">
          <p>Creando registro ... </p>
          <b-spinner label="Loading..." variant="primary"/>
        </div>
        <div v-else>
          <validation-observer ref="registrarCategoria">
            <b-form autocomplete="off" @submit.prevent="agregarRegistro">
              <b-row>
                <b-col lg="12">
                  <b-form-group
                      label="Categoría"
                      label-for="categoria"
                  >
                    <validation-provider
                        #default="{ errors }"
                        name="Categoría"
                        vid="categoria"
                        rules="required"
                    >
                      <b-form-input
                          id="categoria"
                          name="categoria"
                          v-model="categoria"
                          :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col lg="12">
                  <b-form-group
                      label="Sub Categoría"
                      label-for="sub_categoria"
                  >
                    <validation-provider
                        #default="{ errors }"
                        name="Sub Categoría"
                        vid="sub_categoria"
                        rules="required"
                    >
                      <b-form-textarea
                          id="sub_categoria"
                          name="sub_categoria"
                          v-model="sub_categoria"
                          :state="errors.length > 0 ? false:null"
                          rows="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- -------------------------------------------------- -->
                <b-col lg="12">
                  <b-form-group
                      label="Modulo"
                      label-for="modulo"
                  >
                    <validation-provider
                        #default="{ errors }"
                        name="Modulo"
                        vid="modulo"
                        rules="required"
                    >
                      <v-select
                          id="estado"
                          v-model="moduloSelected"
                          :options="modulos"
                          :reduce="modulos => modulos.value"
                          label="text"
                          key="value"
                          placeholder="Seleccionar modulo..."
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- ------------------------------------------------ -->
                <b-col lg="12">
                  <b-form-group
                      label="Estado"
                      label-for="estado"
                  >
                    <validation-provider
                        #default="{ errors }"
                        name="Estado"
                        vid="estado"
                        rules="required"
                    >
                      <v-select
                          id="estado"
                          v-model="estadoSelected"
                          :options="estados"
                          :reduce="estados => estados.value"
                          label="text"
                          key="value"
                          placeholder="Seleccionar estado..."
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </div>
      </b-modal>

      <b-modal
          id="modal-editar"
          ref="modal-editar"
          v-model="mostrarModalEditar"
          no-close-on-esc
          no-close-on-backdrop
          cancel-variant="secondary"
          ok-title="Editar"
          cancel-title="Cancelar"
          :cancel-disabled="loadingEditar"
          :ok-disabled="loadingEditar"
          size="md"
          centered
          title="Editar Registro"
          @ok="okModalEditar"
      >
        <div v-if="loadingRegistrar"  align="center">
          <p>Editando registro ... </p>
          <b-spinner label="Loading..." variant="primary"/>
        </div>
        <div v-else>
          <validation-observer ref="editarCategoria">
            <b-form autocomplete="off" @submit.prevent="editarRegistro">
              <b-row>
                <b-col lg="12">
                  <b-form-group
                      label="Categoría"
                      label-for="categoria"
                  >
                    <validation-provider
                        #default="{ errors }"
                        name="Categoría"
                        vid="categoria"
                        rules="required"
                    >
                      <b-form-input
                          id="categoria"
                          name="categoria"
                          v-model="categoria"
                          :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col lg="12">
                  <b-form-group
                      label="Sub Categoría"
                      label-for="sub_categoria"
                  >
                    <validation-provider
                        #default="{ errors }"
                        name="Sub Categoría"
                        vid="sub_categoria"
                        rules="required"
                    >
                      <b-form-textarea
                          id="sub_categoria"
                          name="sub_categoria"
                          v-model="sub_categoria"
                          :state="errors.length > 0 ? false:null"
                          rows="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!------------------------------------ -->
                <b-col lg="12">
                  <b-form-group
                      label="Modulo"
                      label-for="modulo"
                  >
                    <validation-provider
                        #default="{ errors }"
                        name="Modulo"
                        vid="modulo"
                        rules="required"
                    >
                      <v-select
                          id="modulo"
                          v-model="moduloSelected"
                          :options="modulos"
                          :reduce="modulos => modulos.value"
                          label="text"
                          key="value"
                          placeholder="Seleccionar estado..."
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- ------------------------------------------ -->
                <b-col lg="12">
                  <b-form-group
                      label="Estado"
                      label-for="estado"
                  >
                    <validation-provider
                        #default="{ errors }"
                        name="Estado"
                        vid="estado"
                        rules="required"
                    >
                      <v-select
                          id="estado"
                          v-model="estadoSelected"
                          :options="estados"
                          :reduce="estados => estados.value"
                          label="text"
                          key="value"
                          placeholder="Seleccionar estado..."
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </div>
      </b-modal>
    </div>
  </template>

  <script>

  import {
    BBadge,
    BButton,
    BCard,
    BCardBody, BCol, BForm,
    BFormGroup, BFormInput,
    BFormSelect, BFormTextarea, BFormTimepicker, BInputGroup, BInputGroupAppend, BModal,
    BPagination, BRow,
    BSpinner,
    BTable,
    BTooltip, VBModal,
  } from 'bootstrap-vue'
  import axiosIns from '../../libs/axios'
  import vSelect from 'vue-select'
  import ToastificationContent from '@core/components/toastification/ToastificationContent'
  import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
  import { required } from '@validations'

  export default {
    components: {
      BCard,
      BCardBody,
      BTable,
      BSpinner,
      BBadge,
      BFormGroup,
      BFormSelect,
      BPagination,
      BButton,
      BTooltip,
      BCol,
      BRow,
      BForm,
      BFormInput,
      BFormTimepicker,
      BModal,
      BInputGroup,
      BInputGroupAppend,
      BFormTextarea,
      VBModal,
      vSelect,

      ValidationProvider,
      ValidationObserver,
    },
    directives: {
      'b-modal': VBModal,
    },
    data: () => ({
      loading: false,
      loadingEditar: false,
      loadingRegistrar: false,
      mostrarModalEditar: false,
      items: [],
      // perPage: 10,
      // pageOptions: [10, 15, 20],
      totalRows: 0,
      currentPage: 1,
      sortBy: 'id',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: [
        {
          key: 'acciones',
          label: '# ',
        },
        {
          key: 'categoria',
          label: 'Categoría',
          sortable: true,
        },
        {
          key: 'nombre',
          label: 'Sub Categoría',
          sortable: true,
        },
        // ----------------------------------------
        {
          key: 'modulo',
          label: 'Modulo',
          sortable: true,
        },
        // ---------------------------------------

        {
          key: 'modified',
          label: 'Modificado',
          sortable: true,
        },
        {
          key: 'created',
          label: 'Creado',
          sortable: true,
        },
        {
          key: 'estado',
          label: 'estado',
          sortable: true,
        },
      ],
      status: [
        {
          0: 'Activo',
          1: 'Inactivo',
        },
        {
          0: 'light-success',
          1: 'light-danger',
        }
      ],

      status_modulo: [
        {
          0: 'AGV',
          1: 'ARV',
          2: 'PACKING',
          3: 'CAMPAMENTO',
        },
      ],


      // ------------------------------------------
        modulos: [
          {value: '0', text: "AGV"},
          {value: '1', text: "ARV"},
          {value: '2', text: "PACKING"},
          {value: '3', text: "CAMPAMENTO"},
        ],
        moduloSelected:'1',
      // --------------------------------

      estados: [
        {value: '0', text: "Activo"},
        {value: '1', text: "Inactivo"}
      ],

      estadoSelected: '0',

      modalEditar: false,
      modalRegistrar: false,
      dias: ['LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO', 'DOMINGO'],
      dia: null,
      hora: null,

      codigo: null,
      id_user_e: null,
      id_registro: null,

      categoria: null,
      sub_categoria: null,
      idEditarRegistro: null,

      required,

    }),
    computed: {},
    mounted() {
      this.traerCategorias();
      localize("es");
    },
    methods: {
      traerCategorias(){
        const yo = this
        yo.loading = true

        const config = {
          method: 'get',
          url: '/bbss/categoria/web/'
        }

        axiosIns(config)
            .then(function (response) {
              if(response.status === 200){
                yo.items = response.data;
                yo.items = yo.items.filter(
                invoice => invoice.modulo === '1'
                );
                yo.totalRows = yo.items.length
              }

            })
            .catch(function (error) {
              console.log(error);
            })
            .finally(function (){
              yo.loading = false
            })

      },

      cPaginacion(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },

      abrirModal(datos){
        const yo = this
        yo.modalEditar = true
        yo.dia = datos['valor']
        yo.hora = datos['valor2']
        yo.codigo = datos['cod']
        yo.id_user_e = datos['con_usuario']
        yo.id_registro = datos['id']
      },

      mostrarNotificacion(titulo, icono, texto, variante, tiempo){
        this.$toast({
              component: ToastificationContent,
              props:{
                title: titulo,
                icon: icono,
                text: texto,
                variant: variante
              }
            },
            {
              timeout: tiempo,
              position: 'top-center',
            })
      },

      agregarRegistro(){
        const yo = this
        this.$refs.registrarCategoria.validate().then(success => {
          if (success){
            yo.loadingRegistrar = true

            const data = JSON.stringify({
              'nombre': yo.sub_categoria,
              'categoria': yo.categoria,
              // ---------------------------
              'modulo': yo.moduloSelected,
              // -------------------------
              'estado': yo.estadoSelected,
            })

            const config = {
              method: 'post',
              url: 'bbss/categoria/crear/',
              headers: {
                'Content-Type': 'application/json'
              },
              data: data
            }

            axiosIns(config)
                .then(function (response) {
                  if (response.status === 201){
                    yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se realizó correctamente.", 'success', 5000)
                  }
                })
                .catch(function (error) {
                  console.log(error);
                  yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger', 5000)
                })
                .finally(function (){
                  yo.traerCategorias()
                  yo.$nextTick(() => {
                    yo.$refs['modal-registrar'].toggle('#toggle-btn')
                  })
                  yo.loadingRegistrar = false
                })

          }
        })
      },

      editarRegistro(){
        const yo = this
        this.$refs.editarCategoria.validate().then(success => {
          if (success){
            yo.loadingEditar = true

            const data = JSON.stringify({
              'nombre': yo.sub_categoria,
              'categoria': yo.categoria,
              // ----------------
              'modulo':yo.moduloSelected,
              // -----------------
              'estado': yo.estadoSelected,
            })

            const config = {
              method: 'put',
              url: 'bbss/categoria/editar/' + yo.idEditarRegistro,
              headers: {
                'Content-Type': 'application/json'
              },
              data: data
            }

            axiosIns(config)
                .then(function (response) {
                  if (response.status === 200){
                    yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se editó correctamente.", 'success', 5000)
                  }
                })
                .catch(function (error) {
                  console.log(error);
                  yo.mostrarNotificacion('Error en la edición.', 'BellIcon', error.toString(), 'danger', 5000)
                })
                .finally(function (){
                  yo.traerCategorias()
                  yo.$nextTick(() => {
                    yo.$refs['modal-editar'].toggle('#toggle-btn')
                  })
                  yo.loadingEditar = false
                })

          }
        })
      },

      okModalRegistro(bvModalEvt){
        bvModalEvt.preventDefault()

        this.agregarRegistro()
      },

      okModalEditar(bvModalEvt){
        bvModalEvt.preventDefault()

        this.editarRegistro()
      },

      abrirModalEditar(datos){
        this.mostrarModalEditar = true
        this.idEditarRegistro = datos['id']
        this.categoria = datos['categoria']
        this.sub_categoria = datos['nombre']
        this.moduloSelected=datos['modulo']
        this.estadoSelected = datos['estado']
      },


      resetModal(){
        this.categoria = null
        this.sub_categoria = null
        this.moduloSelected='0'
        this.estadoSelected = '0'
      }
    },
  }
  </script>

  <style lang="scss">

  </style>
